<ng-container *ngIf="canView">
    <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">

        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">attach_money</mat-icon>
                Mis Pagos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="canViewDetalle">
          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end end" class="flex-item">
            <a style="cursor: pointer; margin: 5px;" (click)="viewAll()" [routerLink]="">
              <mat-label>Ver todos los movimientos</mat-label>
            </a>
          </div>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="false" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                    [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
                  <e-columns>
                    <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=90 type='date' format="dd/MM/yyyy">
                      <ng-template #template let-data>
                        {{data.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}
                      </ng-template>
                    </e-column>
                    <e-column field='Detalle' headerText='Detalle' width=100></e-column>
                    <e-column field='MedioPagoNombre' headerText='Medio Pago' width=90></e-column>
                    <e-column field='Monto' headerText='Monto' textAlign="right" width=70>
                      <ng-template #template let-data>
                        {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                      </ng-template>
                    </e-column>
                    <e-column headerText='' width=30>
                      <ng-template #template let-data>
                        <a style="cursor: pointer; margin-right: 5px" (click)="view(data)" *ngIf="canViewDetalle"><i class="fa fa-eye fa-1x"></i></a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
            </div>
        </div>

    </mat-expansion-panel>
</ng-container>